import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import leftimgs from "../../assets/communicationSkillsLeftImg.png";
import rightimgs from "../../assets/communicationSkillsRightImg.png";
// import commSkills from "../../assets/commSkills.png";
// import declOratSkills from "../../assets/declOratSkills.png";
// import argDeb from "../../assets/argDeb.png";
// import CourseExplorer from "../../MyComponents/CourseExplorer";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import API_CONFIG from "../../config/api";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
// import img1 from "../../assets/Communication Skills/Group 22.png"
// import img2 from "../../assets/Communication Skills/Rectangle 5.png"
// import img3 from "../../assets/Communication Skills/Group 22-1.png"

// import icon1 from "../../assets/Communication Skills/Group 1686551979.png"
// import icon2 from "../../assets/Communication Skills/Vector.png"
// import icon3 from "../../assets/Communication Skills/Group.png"
const courses = [
  {
    title: "Communication Skills",
    image: "Polymath-images/Communication Skills/Group 22.png",
    icon: "Polymath-images/Communication Skills/Group 1686551979.png",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/comm_comm_skills"
  },
  {
    title: "Declamation & Oratory Skills (Coming Soon)",
    image: "Polymath-images/Communication Skills/Rectangle 5.png",
    icon: "Polymath-images/Communication Skills/Vector.png",
    color: "#9956bbff",
    age: "Age: 12+",
    // link: "/graphic_designing_corel" 
  },
  {
    title: "Argumentation & Debate (Coming Soon)",
    image: "Polymath-images/Communication Skills/Group 22-1.png",
    icon: "Polymath-images/Communication Skills/Group.png",
    color: "#66c0ccff",
    age: "Age: 12+",
    // link: "/coding_web_development"
  }


];
const CommunicationPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <div className="stem-container">
      <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
      <h1 className="stem-title">Communication Skill Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.title} className="course-card">
            <Link to={course.link} className="course-link">

              <div className="course-image-container">
                <img
                  src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                  alt={course.title}
                  className="course-image"
                />
                <span className="ages-badge">{course.age}</span>
              </div>

              <div className="icon-container" style={{ backgroundColor: course.color }}>
                <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
              </div>

              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
        <img src={pencilIcon} alt="icon" className="pobtn-icon" />
        Book Free Demo Class
      </button>
    </div>
  );
};

const CommunicationPortal = () => {
  const communicationpage = heroContent.communicationpage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/communicationSkillsLeftImg.png"}
        rightImg={'Polymath-images/communicationSkillsRightImg.png'}
        titlePart1="Empowering Young Minds to"
        titlePart2="Speak with Confidence"
        description="At Polymath-Kids, we believe strong communication is the key to success-both in academics and in life. Our Communication Skills for Kids program is thoughtfully designed to help children express themselves confidently, listen actively, and interact respectfully with others."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />

      <CommunicationPopularCourses />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default CommunicationPortal;
